import styled from 'styled-components';
import { useContext } from 'react';
import { SidebarStateContext } from '../../../providers/MainProviders';
import AppLogoImage from '../../../assets/images/repraise-logo.png';
import Icon from '../../../assets/images/repraise-icon.png';
import { useTranslation } from 'react-i18next';

const HeaderContainer = styled.div`
  display: flex;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  align-items: center;
  justify-content: center;
  min-height: 64px;
  padding: ${(props) => props.theme.spacing(1)};
  background-color: ${(props) => props.theme.palette.background.paper};
  z-index: 1;
`;

const SidebarHeader = () => {
  const { expanded } = useContext(SidebarStateContext);
  const { t } = useTranslation();

  return (
    <HeaderContainer>
      {expanded ? (
        <img
          src={AppLogoImage}
          width="50%"
          alt={t('app_logo_alt')}
        />
      ) : (
        <img
          src={Icon}
          width="60%"
          alt={t('app_logo_alt')}
        />
      )}
    </HeaderContainer>
  );
};

export default SidebarHeader;
